import { api } from './api'

function assertSuccess(body: unknown) {
  const b = body as { success?: boolean; message?: string; data?: unknown }
  if (!b?.success) {
    throw new Error(b?.message || 'Request failed')
  }
  return b.data
}

function apiError(err: unknown, fallback: string) {
  const e = err as { response?: { data?: { message?: string } }; message?: string }
  return new Error(e?.response?.data?.message || e?.message || fallback)
}

export type NewsletterOverview = {
  totalSubscribers: number
  totalStoresWithSubscribers: number
  topStores: Array<{
    storeId: number
    storeName: string | null
    organisationName: string | null
    subscriberCount: number
  }>
  recent: Array<{
    id: number
    email: string
    storeId: number
    storeName: string | null
    organisationName: string | null
    source: string
    subscribedAt: string
  }>
}

export type PlatformNewsletterRow = {
  id: number
  storeId: number
  email: string
  status: string
  source: string
  subscribedAt: string
  unsubscribedAt: string | null
  createdAt: string
  organisationId: number
  organisationName: string | null
  storeName: string | null
}

export async function fetchNewsletterOverview(): Promise<NewsletterOverview> {
  try {
    const { data } = await api.get('/admin/newsletter/overview')
    return assertSuccess(data) as NewsletterOverview
  } catch (e) {
    throw apiError(e, 'Failed to load newsletter overview')
  }
}

export async function fetchPlatformNewsletterSubscribers(params?: {
  page?: number
  limit?: number
  q?: string
  status?: 'subscribed' | 'unsubscribed'
  storeId?: number
}): Promise<{
  items: PlatformNewsletterRow[]
  total: number
  page: number
  limit: number
}> {
  try {
    const { data } = await api.get('/admin/newsletter/subscribers', { params })
    return assertSuccess(data) as {
      items: PlatformNewsletterRow[]
      total: number
      page: number
      limit: number
    }
  } catch (e) {
    throw apiError(e, 'Failed to load subscribers')
  }
}
